import React, { FC } from 'react';
import { ExpanderPanel } from './ExpanderPanel';
import { ExpanderPanelGroup } from './ExpanderPanelGroup';
import { Spacer } from './Spacer';
import { LocationListFragment } from '../types/graphqlTypes';
import { Section } from './Section';
import { StyledLinkList } from './LinkList';
import { IconLink } from './IconLink';

export interface LocationListProps extends LocationListFragment {
  width: 'narrow' | 'wide';
}

export const LocationList: FC<Omit<LocationListProps, '__typename'>> = ({ regions, width, ...rest }) => {
  if (regions?.length < 1) {
    return null;
  }

  return (
    <Section contained narrow={width === 'narrow'} {...rest}>
      <ExpanderPanelGroup as="ul">
        {regions?.length >= 1 &&
          regions.map((region, index) => {
            const areas = region?.areas?.edges;
            return (
              <ExpanderPanel
                key={region.id}
                title={region.name}
                as="li"
                headingVariant="titleMedium"
                headingComponent="h2"
              >
                <Spacer>
                  {region.shortDescription && <p>{region.shortDescription}</p>}

                  <StyledLinkList gridNarrow={width === 'narrow'} grid>
                    {areas.map((area) => (
                      <li key={area?.node?.id}>
                        {area?.node?.relativeUrl && (
                          <IconLink
                            label={area?.node.name}
                            url={area?.node.relativeUrl}
                            arrowLeft
                            eventClickSection={region.name}
                          />
                        )}
                      </li>
                    ))}
                  </StyledLinkList>

                  {region?.relativeUrl && (
                    <IconLink label={`View all ${region.name} area guides`} url={region.relativeUrl} arrowRight />
                  )}
                </Spacer>
              </ExpanderPanel>
            );
          })}
      </ExpanderPanelGroup>
    </Section>
  );
};
